module.exports = __webpack_public_path__ + "img/embalagem.c512561e.png";